import { render, staticRenderFns } from "./traMediciplan.vue?vue&type=template&id=0cb927e3&scoped=true"
import script from "./traMediciplan.vue?vue&type=script&lang=js"
export * from "./traMediciplan.vue?vue&type=script&lang=js"
import style0 from "./traMediciplan.vue?vue&type=style&index=0&id=0cb927e3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb927e3",
  null
  
)

export default component.exports